import { createContext, useContext, useMemo, useState } from 'react';
import { getOrgType } from '../authUtils';

const WorkflowBarContext = createContext(null);

function WorkflowBarProvider({ children }) {
  const [counts, setCounts] = useState({});
  const [overdueCounts, setOverdueCounts] = useState({});
  const [totalReferrals, setTotalReferrals] = useState(0);
  const [visible, setVisible] = useState(false);
  const [assignedToFilter, setAssignedToFilter] = useState(() => {
    const orgType = getOrgType();
    return orgType === 'TPA' || orgType === 'CARRIER' ? 'tpa_carrier' : 'all';
  });
  const [workflowStepFilter, setWorkflowStepFilter] = useState(null);
  const [isClosedFilter, setIsClosedFilter] = useState(false);
  const [qsActive, setQsActive] = useState(false);
  // stepLabels: array of { key, label } ordered by backend WorkflowStep enum
  const [stepLabels, setStepLabels] = useState([]);

  const value = useMemo(() => ({
    counts, setCounts,
    overdueCounts, setOverdueCounts,
    totalReferrals, setTotalReferrals,
    visible, setVisible,
    assignedToFilter, setAssignedToFilter,
    workflowStepFilter, setWorkflowStepFilter,
    qsActive, setQsActive,
    stepLabels, setStepLabels,
    isClosedFilter, setIsClosedFilter,
  }), [counts, overdueCounts, totalReferrals, visible, assignedToFilter, workflowStepFilter, qsActive, stepLabels, isClosedFilter]);

  return (
    <WorkflowBarContext.Provider value={value}>
      {children}
    </WorkflowBarContext.Provider>
  );
}

function useWorkflowBar() {
  return useContext(WorkflowBarContext);
}

export { WorkflowBarProvider, useWorkflowBar };
